import { render, staticRenderFns } from "./SolusiOrangTua.vue?vue&type=template&id=1d0dce33&"
import script from "./SolusiOrangTua.vue?vue&type=script&lang=js&"
export * from "./SolusiOrangTua.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports